import { fbt } from 'fbtee'
import { CountBadge } from '../../components/CountBadge'
import { PillButton } from '../../components/PillButton'

export type GroupView = 'events' | 'members' | 'totems'

/** Events | Members | Totems pills under the group header — the same shape as the profile's tabs. */
export function GroupViewNav({
  view,
  onChange,
  memberCount,
  showTotems,
  pendingCount = 0,
}: {
  view: GroupView
  onChange: (view: GroupView) => void
  memberCount: number
  /** Members only — guests can't make or follow a group's totems from here. */
  showTotems: boolean
  /** Suggestions waiting on the viewer (admins only) — a count badge on Events. */
  pendingCount?: number
}) {
  return (
    <div className="flex gap-1 shrink-0">
      <PillButton active={view === 'events'} onClick={() => onChange('events')}>
        <span className="inline-flex items-center gap-1.5">
          {fbt('Events', 'Pill nav label for the events tab on a group page')}
          {/* A to-do count, not "unread": it stays on its own tab too, inverted on the active pill. */}
          <CountBadge
            count={pendingCount}
            className={view === 'events' ? 'bg-primary-foreground text-primary' : undefined}
            data-testid="group-pending-count"
          />
        </span>
      </PillButton>
      <PillButton active={view === 'members'} onClick={() => onChange('members')}>
        <fbt desc="Pill nav label for the members tab on a group page, with the member count">
          Members · <fbt:param name="count">{memberCount}</fbt:param>
        </fbt>
      </PillButton>
      {showTotems && (
        <PillButton active={view === 'totems'} onClick={() => onChange('totems')}>
          {fbt('Totems', 'Pill nav label for the totems tab on a group page')}
        </PillButton>
      )}
    </div>
  )
}
